import { axios } from '@/lib/axios';

export const getOrderDetails = async (id: number) => {
    const { data } = await axios.get(`v1/get-orders-details?id=${id}`);
    return data;
};
